import { useLang } from "hooks/useLang"


interface IAuthHeader {
    title: string
    description: string
}

const AuthHeader = ({
    title, description
}: IAuthHeader) => {
    const { t } = useLang()
    return (
        <>
            <h2 className="md:text-2xl text-xl mb-3 px-2 font-semibold">
                {t(title)}
            </h2>
            <p className="text-sm md:text-md mb-5 px-2 text-[#7B91EF]">
                {t(description)}
            </p>
        </>
    )
}

export default AuthHeader
